import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import CurrencyInput from 'react-currency-input-field';

DialogActivateChargeConnectorView.propTypes = {
  pricing: PropTypes.object,
  item: PropTypes.object.isRequired,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogActivateChargeConnectorView({ pricing, item, onCancel, onDone }) {
  // MARK: ---- PROPERTIES ----
  const supportedPaymentMethods = useMemo(() => {
    return [ChargeConstants.ChargePaymentMethod.CASH];
  }, []);
  const [loading, setLoading] = useState(false);
  const [readyToValidate, setReadyToValidate] = useState(false);
  const [plate, setPlate] = useState();
  const [currentBatteryPercent, setCurrentBatteryPercent] = useState();
  const [vehicleBrand, setVehicleBrand] = useState();
  const [vehicleModel, setVehicleModel] = useState();
  const [paymentMethod, setPaymentMethod] = useState(ChargeConstants.ChargePaymentMethod.CASH);
  const [driver, setDriver] = useState();
  const [vehicleId, setVehicleId] = useState();
  const [vehicleOptions, setVehicleOptions] = useState([]);
  useEffect(() => {
    const vehicles = driver?.vehicles ?? [];
    setVehicleOptions(
      vehicles.map((item) => {
        return {
          name: item?.plate,
          value: item?.vehicleId,
        };
      })
    );
  }, [driver]);
  const [amount, setAmount] = useState();
  const [energyConvert, setEnergyConvert] = useState();
  const [vehicleBrandList, setVehicleBrandList] = useState([]);
  useEffect(() => {
    ChargeHelper.API.VehicleBrand.requestGetVehicleBrandList().then((data) => {
      setVehicleBrandList(data.brands);
    });
  }, []);
  const [dropdownVehicleBrandOptions, setDropdownVehicleBrandOptions] = useState([]);
  useEffect(() => {
    if (!vehicleBrandList || vehicleBrandList.length === 0) return;
    const options = vehicleBrandList.map((item) => {
      return {
        name: item.name,
        brandId: item.brandId,
      };
    });
    setDropdownVehicleBrandOptions(options);
  }, [vehicleBrandList]);
  useEffect(() => {
    if (!pricing || !amount) return;
    const iAmount = amount ? _.toNumber(amount.replace(',', '.')) : 0;
    let pricingConvert = 0;
    const pricingMode = pricing?.pricingMode;
    if (pricingMode === ChargeConstants.ChargePricingMode.FLAT) {
      pricingConvert = pricing?.flatPrice;
    } else {
      pricingConvert = 0;
    }
    setEnergyConvert(
      iAmount > 0 && pricingConvert > 0 ? (iAmount / pricingConvert).toFixed(2) : null
    );
  }, [pricing, amount]);

  // MARK: ---- METHODS ----
  const handleSubmit = async () => {
    setReadyToValidate(true);
    if (paymentMethod === ChargeConstants.ChargePaymentMethod.WALLET) {
      if (!Utils.isValid(driver)) {
        ToastHelper.showError('Vui lòng chọn khách hàng');
        return;
      }
      if (!Utils.isValid(vehicleId)) {
        ToastHelper.showError('Vui lòng chọn xe');
        return;
      }
      if (!Utils.isValid(amount) || _.toNumber(amount.replace(',', '.')) <= 0) {
        ToastHelper.showError('Vui lòng nhập số tiền muốn sạc');
        return;
      }
    }
    if (paymentMethod === ChargeConstants.ChargePaymentMethod.CASH) {
      if (!Utils.isValid(plate)) {
        ToastHelper.showError('Vui lòng nhập biển số xe');
        return;
      }
      if (!Utils.isValid(amount) || _.toNumber(amount.replace(',', '.')) <= 0) {
        ToastHelper.showError('Vui lòng nhập số tiền muốn sạc');
        return;
      }
    }
    let params = {
      currency: 'VND',
      pointId: item?.pointId,
      connectorNumber: item?.connectorNumber,
      prepaidAmount: amount,
      plate: plate,
      paymentMethod: paymentMethod,
      // startingPercentage: currentBatteryPercent,
      // batteryCapacity: vehicleModel?.batteryCapacity,
      // vehicleModelId: vehicleModel?.id,
    };
    params = _.omitBy(params, _.isNil);
    console.log(params);
    // return;
    setLoading(true);
    const res = await ChargeHelper.API.requestActivateCharger(params);
    setLoading(false);
    if (_.isBoolean(res) && res) {
      ToastHelper.showSuccess('Kích hoạt súng sạc thành công');
      onDone();
    } else if (_.isString(res)) {
      ToastHelper.showError(res);
    }
  };

  return (
    <div>
      <div
        className="d-flex flex-column align-items-center justify-content-center text-center px-5 pt-6 gap-2 pb-4"
        style={{
          borderBottom: `1px dashed ${AppColors.gray[300]}`,
        }}
      >
        <div className="mb-4">
          <img src={AppResource.images.dialogIcons.dialogActiveChargeConnector} />
        </div>

        <span style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[800])}>
          Kích hoạt súng sạc
        </span>
        <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>
          Vui lòng nhập đủ các thông tin bên dưới để tiến hành kích hoạt súng sạc và bắt đầu quá
          trình sạc xe.
        </span>
      </div>

      <div className="row m-0 p-0 px-3 mt-4">
        {/* left */}
        <div className="col-12 px-2 mb-4">
          {/* phuong thuc thanh toan QR */}
          {[
            ChargeConstants.ChargePaymentMethod.QR,
            // ChargeConstants.ChargePaymentMethod.CASH,
          ].includes(paymentMethod) && (
              <div className="mb-4">
                {UIHelper.buildFormLabel('Chọn phương tiện')}
                <CustomDropdown2
                  id="chooseVehicle"
                  name="chooseVehicle"
                  toggleElement={
                    <button
                      className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                      type="button"
                    >
                      {vehicleModel?.name ?? 'Chọn phương tiện'}
                    </button>
                  }
                  selectedValue={vehicleModel}
                  dropdownMenuItems={dropdownVehicleBrandOptions}
                  getSubItems={async (item) => {
                    const brandId = item?.brandId;
                    if (Utils.isValid(brandId)) {
                      return ChargeHelper.API.VehicleModel.requestGetVehicleModelList(
                        brandId,
                        {}
                      ).then((data) => {
                        return {
                          values: data.models?.map((model) => ({
                            id: model?.modelId,
                            name: model?.name,
                            batteryCapacity: model?.batteryCapacity,
                          })),
                          total: data.total,
                        };
                      });
                    }
                  }}
                  dropdownMenuStyle={{ maxHeight: '30vh' }}
                  dropdownMenuClassName="overflow-auto w-100"
                  onChange={(value) => {
                    setVehicleModel(value);
                  }}
                  isDropdownForm={true}
                  titleSearchable={true}
                  searchable={true}
                  searchFormClassName="mx-3 my-1 search-form-border"
                  ignoreConfirmClick={true}
                />
              </div>
            )}
          {/* bien so xe */}
          <div className="">
            {UIHelper.buildFormLabel('Biển số xe', true)}
            <KTFormInput
              type={KTFormInputType.text}
              placeholder="Nhập biển số xe"
              name="plate"
              value={plate}
              onChange={(value) => {
                setPlate(value);
              }}
              enableCheckValid={readyToValidate}
              isValid={true}
              isTouched={readyToValidate}
            />
          </div>
          {/* phuong thuc thanh toan WALLET */}
          {paymentMethod === ChargeConstants.ChargePaymentMethod.WALLET && (
            <>
              {/* chon khach hang */}
              <div className="mb-4">
                {UIHelper.buildFormLabel('Chọn khách hàng', true)}
                <CustomDropdown2
                  id="chooseDriver"
                  name="chooseDriver"
                  toggleElement={
                    <button
                      className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                      type="button"
                    >
                      {driver?.name ?? 'Chọn khách hàng'}
                    </button>
                  }
                  selectedValue={driver}
                  dropdownMenuItems={[{ name: 'Khách hàng', role: 'DRIVER' }]}
                  getSubItems={async (item) => {
                    return ChargeHelper.API.Driver.requestGetDriverList({
                      page: item?.page || 0,
                      limit: 10,
                      q: item?.q || '',
                    }).then((data) => {
                      return {
                        values: data.drivers?.map((driver) => ({
                          id: driver?.userId,
                          name: driver?.fullname,
                          vehicles: driver?.vehicles ?? [],
                        })),
                        total: data.total,
                      };
                    });
                  }}
                  dropdownMenuStyle={{ maxHeight: '30vh' }}
                  dropdownMenuClassName="overflow-auto w-100"
                  onChange={(value) => {
                    setDriver(value);
                    setVehicleId(null);
                  }}
                  isDropdownForm={true}
                  titleSearchable={true}
                  searchable={true}
                  searchFormClassName="mx-3 my-1 search-form-border"
                  ignoreConfirmClick={true}
                  defaultValue={{
                    name: 'Khách hàng',
                    role: 'DRIVER',
                  }}
                />
              </div>
              {/* chon xe */}
              <div className="mb-4">
                {UIHelper.buildFormLabel('Chọn xe', true)}
                <KTBSDropdown
                  name="chooseVehicle"
                  toggleElement={
                    <button
                      className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                      type="button"
                    >
                      {vehicleId
                        ? _.find(vehicleOptions, (item) => item?.value == vehicleId)?.name
                        : 'Chọn xe'}
                    </button>
                  }
                  selectedValue={vehicleId}
                  dropdownMenuItems={vehicleOptions}
                  dropdownMenuClassName="overflow-auto w-100"
                  dropdownMenuStyle={{ maxHeight: '30vh' }}
                  onChange={(value) => {
                    setVehicleId(value);
                    const vehicle = _.find(driver?.vehicles, (item) => item?.vehicleId == value);
                    setPlate(vehicle?.plate);
                  }}
                  isDropdownForm={true}
                />
              </div>
            </>
          )}

          {/* muc pin hien tai */}
          {/* <div className="mb-4">Compar
            <div className="d-flex align-items-center gap-1">
              {UIHelper.buildFormLabel('Mức pin hiện tại')}
              <KTTooltip text="Nhập mức pin và dòng xe vào sạc để ước tính ra số tiền khách hàng cần sạc đầy pin.">
                <i
                  className="fa-regular fa-circle-info"
                  style={{ color: 'rgba(41, 132, 238, 1)' }}
                />
              </KTTooltip>
            </div>
            <KTFormInput
              type={KTFormInputType.currency}
              unit="%"
              placeholder="Nhập mức pin hiện tại"
              name="currentBatteryPercent"
              value={currentBatteryPercent}
              onChange={(value) => {
                const iValue = value ? _.toNumber(value.replace(',', '.')) : null;
                setCurrentBatteryPercent(iValue);
              }}
              enableCheckValid={true}
              isValid={
                !Utils.isValid(currentBatteryPercent) ||
                (currentBatteryPercent >= 0 && currentBatteryPercent <= 100)
              }
              isTouched={readyToValidate}
            />
          </div> */}
        </div>
        {/* right */}
        <div className="col-12 px-2 mb-4">
          {/* phuong thuc thanh toan */}
          <div className="mb-4">
            {UIHelper.buildFormLabel('Phương thức thanh toán', true)}
            <KTBSDropdown
              name="paymentMethod"
              toggleElement={
                <button
                  className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                  type="button"
                >
                  {ChargeHelper.Utils.getChargePaymentMethodName(paymentMethod) ?? 'Chọn phương thức thanh toán'}
                </button>
              }
              selectedValue={paymentMethod}
              dropdownMenuItems={_.filter(ChargeHelper.Data.chargePaymentMethodOptions, (item) =>
                supportedPaymentMethods.includes(item?.value)
              )}
              dropdownMenuClassName="overflow-auto w-100"
              dropdownMenuStyle={{ maxHeight: '30vh' }}
              onChange={(value) => {
                setPaymentMethod(value);
              }}
              isDropdownForm={true}
            />
          </div>

          {/* so tien muon sac */}
          <div className="">
            {UIHelper.buildFormLabel('Số tiền muốn sạc', true)}
            <div
              className="position-relative overflow-hidden"
              style={{
                borderRadius: '5px',
                border: `1px solid ${AppColors.gray[300]}`,
              }}
            >
              {/* amount */}
              <div
                style={{ height: '42px', borderBottom: `1px solid ${AppColors.gray[300]}` }}
                className="d-flex align-items-center"
              >
                <div
                  className="h-100 d-flex align-items-center justify-content-center"
                  style={{
                    ...UIHelper.buildFontStyle('400', '14px', AppColors.gray[800]),
                    width: '55px',
                    borderRight: `1px solid ${AppColors.gray[300]}`,
                  }}
                >
                  VNĐ
                </div>
                <CurrencyInput
                  name="amount"
                  value={amount}
                  placeholder="Nhập số tiền muốn sạc"
                  className={`form-control mt-0 border-0 flex-grow-1`}
                  style={{ width: 'auto', height: 'calc(100% - 2px)' }}
                  decimalSeparator=","
                  groupSeparator="."
                  defaultValue={0}
                  decimalsLimit={2}
                  onValueChange={(value) => {
                    setAmount(value);
                  }}
                />
              </div>
              {/* energy convert */}
              <div
                style={{ height: '42px', backgroundColor: AppColors.gray[200] }}
                className="d-flex align-items-center"
              >
                <div
                  className="h-100 d-flex align-items-center justify-content-center"
                  style={{
                    ...UIHelper.buildFontStyle('400', '14px', AppColors.gray[800]),
                    width: '55px',
                    borderRight: `1px solid ${AppColors.gray[300]}`,
                  }}
                >
                  kWh
                </div>
                <div
                  className="px-3 d-flex align-items-center gap-1"
                  style={UIHelper.buildFontStyle('500', '13px', AppColors.gray[800])}
                >
                  {energyConvert ?? 'Số điện quy đổi'}{' '}
                  {pricing && pricing?.pricingMode === ChargeConstants.ChargePricingMode.HOURS && (
                    <KTTooltip text="Trụ sạc đang được cài đặt đơn giá theo khung giờ nên không thể quy đổi ra kWh.">
                      <i className="fa-regular fa-triangle-exclamation text-danger" />
                    </KTTooltip>
                  )}
                </div>
              </div>
              {/* icon convert */}
              <div
                className="position-absolute d-flex align-items-center justify-content-center bg-white"
                style={{
                  width: '30px',
                  aspectRatio: '1/1',
                  border: `1px solid ${AppColors.gray[300]}`,
                  borderRadius: '50%',
                  right: '10px',
                  top: 'calc(50% - 15px)',
                }}
              >
                <i
                  className="fa-regular fa-arrows-repeat"
                  style={{
                    transform: 'rotate(90deg)',
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="d-flex align-items-center justify-content-center gap-3 px-4 py-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null, true)}
        {UIHelper.buildGreenButton('Kích hoạt', handleSubmit, null, true, loading)}
      </div>
    </div>
  );
}

export default DialogActivateChargeConnectorView;
